import { render, staticRenderFns } from "./CodeOfPractice.vue?vue&type=template&id=2b96d576&"
import script from "./CodeOfPractice.vue?vue&type=script&lang=js&"
export * from "./CodeOfPractice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports